import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { TradeSessionDetailCardProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  card: {
    width: '100%',
    paddingBlock: token.padding,
    paddingInline: token.paddingLG,
    backgroundColor: token.colorWhite,
    borderRadius: token.borderRadiusSM,
    border: `1px solid ${token.colorBorderSecondary}`
  },
  title: {}
}))

export const TradeSessionDetailCard = ({
  className,
  classNames,
  style,
  title,
  children
}: PropsWithChildren<TradeSessionDetailCardProps>) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.card, className)} style={style}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={classNames?.body}>{children}</div>
    </div>
  )
}
